import styled from "styled-components";

import { SkeletonBlock } from "components/admin";

export const ProtectedRouteSection = styled.div.attrs({
  className: "flex min-h-screen items-center justify-center bg-[var(--brand-bg)] px-6",
})``;

export const ProtectedRouteContentStack = styled.div.attrs({
  className: "brand-panel w-full max-w-sm space-y-4",
})``;

export const ProtectedRouteSkeletonLine = styled(SkeletonBlock).attrs({
  className: "h-3 w-24 rounded-full",
})``;

export const ProtectedRouteSkeletonLineSecondary = styled(SkeletonBlock).attrs({
  className: "h-5 w-48 rounded-full",
})``;

export const ProtectedRouteSkeletonField = styled(SkeletonBlock).attrs({
  className: "h-4 w-full rounded-full",
})``;

export const ProtectedRouteSkeletonLineTertiary = styled(SkeletonBlock).attrs({
  className: "h-4 w-4/5 rounded-full",
})``;
